import { clone, saveRecord } from './model.js'
import { canAction } from './panelPermissions.js'
const newId = () => `draft:${crypto.randomUUID()}`
export function saveCommercialBundle(db, kind, payload, context) {
  const record = clone(payload.record), exists = db[kind].some(item => item.id === record.id)
  if (!canAction(db, kind, exists ? 'edit' : 'create', context)) return { errors: ['Você não tem permissão para manter este cadastro.'] }
  record.id = record.id || newId()
  let pending = clone(db)
  if (payload.manager) {
    const result = saveRecord(pending, 'managers', { ...payload.manager, id: newId(), representativeId: record.representativeId, requirePasswordChange: true }, context)
    if (result.errors.length) return result
    pending = result.database; record.managerId = result.record.id
  }
  if (kind === 'representatives') {
    const index = pending.representatives.findIndex(rep => rep.id === record.id)
    if (index < 0) pending.representatives.push(clone(record)); else pending.representatives[index] = clone(record)
    for (const member of payload.team || []) {
      const result = saveRecord(pending, 'panelUsers', { ...member, id: member.id || newId(), representativeId: record.id }, context)
      if (result.errors.length) return result
      pending = result.database
    }
    if (Array.isArray(payload.planIds)) for (const plan of [...pending.plans]) {
      const selected = payload.planIds.includes(plan.id), linked = plan.representativeIds.includes(record.id)
      if (selected === linked) continue
      const result = saveRecord(pending, 'plans', { ...plan, representativeIds: selected ? [...plan.representativeIds, record.id] : plan.representativeIds.filter(id => id !== record.id) }, context)
      if (result.errors.length) return result
      pending = result.database
    }
  }
  if (kind === 'accountingOffices') {
    const index = pending.accountingOffices.findIndex(office => office.id === record.id)
    if (index < 0) pending.accountingOffices.push(clone(record)); else pending.accountingOffices[index] = clone(record)
    for (const member of payload.team || []) {
      const result = saveRecord(pending, 'accountingUsers', { ...member, id: member.id || newId(), representativeId: record.representativeId, officeId: record.id }, context)
      if (result.errors.length) return result
      pending = result.database
    }
  }
  if (['representatives', 'accountingOffices'].includes(kind)) {
    const original = db[kind].find(item => item.id === record.id)
    pending[kind] = pending[kind].filter(item => item.id !== record.id)
    if (original) pending[kind].splice(db[kind].findIndex(item => item.id === record.id), 0, clone(original))
  }
  return saveRecord(pending, kind, record, context)
}
